<template>
  <n-scroll>
    <div class="detection-page">
      <div class="part1">
        <n-status-bar v-bind="nav" />
        <n-control2500
          @click="control2500Click"
          v-if="params.deviceTypeCode === 'CR2500'"
          :loading="loading"
          :status.sync="status"
        />
        <n-control3000
          v-if="params.deviceTypeCode === 'CR3000'"
          @click="control3000Click"
          :loading="loading"
          :status.sync="status"
          :mode.sync="mode"
        />
      </div>
      <div class="part2">
        <n-details @report="report" v-show="msg" :msg="msg" />
      </div>
    </div>
  </n-scroll>
</template>

<script>
import NScroll from '../../components/NScroll';
import NControl3000 from './components/control/cr3000';
import NControl2500 from './components/control/cr2500';
import NStatusBar from './components/status-bar';
import NDetails from './components/details';
import { start, finish } from '@/api/remoteControl';
import { modeMap } from './utils';
import { subscribe, envPrefix } from '@/utils/mqtt';
import { deviceStatueServer } from '@/api/remoteControl';

export default {
  name: 'VPDetection',
  components: {
    NScroll,
    NControl3000,
    NControl2500,
    NStatusBar,
    NDetails
  },
  inject: ['calc', 'router', 'params'],
  sockets: {
    '/socket/remote/control'(msg) {
      this.$message.warning(msg.message);
      this.stop();
      this.msg = msg;
    }
    // '/socket/remote/connect'(msg) {
    //   const { message, sn } = msg || {};
    //   if (`${sn}` === `${this.params.sn}`) {
    //     this.nav.right = !parseInt(message);
    //   }
    // }
  },
  data() {
    return {
      status: 'stop',
      deviceStatus: '',
      mode: 'quick',
      loading: false,
      msg: null,
      nav: {
        left: false,
        center: false,
        right: false
      }
    };
  },
  methods: {
    // 检测在线状态
    watchStatus() {
      const params = {
        sn: [this.params.sn]
      };
      deviceStatueServer(params).then(res => {
        //  0 在线 1 离线 2 监测中
        if (res.data.status === '0') {
          this.nav.right = true;
          this.status = 'run';
        } else {
          this.status = 'stop';
        }
      });
    },
    stop(delay = 500) {
      const timer = setTimeout(() => {
        clearTimeout(timer);
        this.status = 'stop';
        this.loading = false;
      }, delay);
    },
    start(mode) {
      this.msg = null;
      const params = {
        sn: [this.params.sn]
      };
      if (mode) params[mode] = modeMap[mode];
      this.loading = true;
      start(params)
        .then(res => {
          if (res.data === 'fail') this.stop();
        })
        .catch(this.stop);
      // .finally(() => {
      //   this.loading = false;
      // });
    },
    finish() {
      const params = {
        sn: '09020034210002',
        testId: 'e44b8ab8-4ff3-4d4c-a838-2864a13498b9'
      };
      finish(params);
      // .then(res => {
      //   console.log(res);
      // })
      // .catch(err => {
      //   console.log(err);
      // });
    },
    validStatu() {
      if (this.nav.right) return true;
      this.$message.warning('设备未开启远程控制');
      this.stop(0);
      return false;
    },
    control3000Click(mode, status) {
      if (!this.validStatu()) return;
      if (status === 'run') this.start(mode);
      if (status === 'stop') this.finish();
    },
    control2500Click(status) {
      if (!this.validStatu()) return;
      if (status === 'run') this.start();
      if (status === 'stop') this.finish();
    },
    report() {
      this.router.goto('detectionReport');
    }
  },
  watch: {
    status(n) {
      this.nav.center = n === 'run';
    }
  },
  created() {
    // console.log('======================', envPrefix);
    // get({ offset: 1, limit: 10, sn: [this.params.sn] });
    // console.log('sn', this.params.sn);

    //  1 订阅设备上线
    this.stopOnline = subscribe(`${envPrefix}/remote/${this.params.sn}/online/`, () => {
      // console.log('🚀 ~ file: index.vue:142 ~ created ~ res:', res);
    });

    // 2 订阅设备下线
    this.stopOffline = subscribe(`${envPrefix}/remote/${this.params.sn}/offline/`, () => {
      // console.log('offline', res);
    });

    // 3 检测完成
    this.finishCheckMqtt = subscribe(`${envPrefix}/remote/${this.params.sn}/finish/`, () => {
      // console.log('check finish', res);
    });

    // 4 获取设备在线状态
    this.watchStatus();
    this.timer = setInterval(() => {
      this.watchStatus();
    }, 5000);
  },
  beforeDestroy() {
    this.stopOnline();
    this.stopOffline();
    this.finishCheckMqtt();
    // clearInterval(this.timer);
  }
};
</script>

<style lang="scss">
.detection-page {
  height: 100%;
  .part1 {
    height: 54%;
    display: flex;
    flex-direction: column;
    .status {
      min-height: 18%;
      max-height: 18%;
    }
  }
  .part2 {
    height: 45.5%;
    background: url('~@/assets/image/virtual-phone/detect/bg2.png') no-repeat center;
    background-size: contain;
    overflow: hidden;
    display: flex;
    justify-content: center;
    padding-top: 10px;
    box-sizing: border-box;
  }
}
</style>
